// extracted by mini-css-extract-plugin
module.exports = {"widget":"NotesAttachmentWidget_widget__mdRps","close":"NotesAttachmentWidget_close__jmBJI"};